import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { akEditorSelectedNodeClassName } from '@atlaskit/editor-shared-styles';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var ruleStyles = css(_defineProperty({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror hr': {
    border: 'none',
    backgroundColor: "var(--ds-border, #091E4224)",
    height: '2px',
    borderRadius: '1px',
    // this should use token('radius.full') but cannot since the element has padding which increases its height beyond 2px
    cursor: 'pointer',
    padding: "var(--ds-space-050, 4px)".concat(" 0"),
    margin: "var(--ds-space-300, 24px)".concat(" 0"),
    backgroundClip: 'content-box'
  }
}, ".ProseMirror hr.".concat(akEditorSelectedNodeClassName), {
  outline: 'none',
  backgroundColor: "var(--ds-border-selected, #0C66E4)"
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var dangerRuleStyles = css(_defineProperty({}, ".ProseMirror hr.".concat(akEditorSelectedNodeClassName, ".danger"), {
  backgroundColor: "var(--ds-border-danger, #E2483D)"
}));